import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { bodymetrixRegiaoApi } from "../../services/Api";
import { ListApi, FormApi, List, CrudForm } from "elentari";

export function BodymetrixRegiaoList(props) {
  const listOptions = {
    defaultOrder: "nome",
    fields: {
      id: {
        label: "Id",
      },
      nome: {
        label: "Região",
      },
    },
  };

  return (
    <ListApi api={bodymetrixRegiaoApi}>
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          labelNew="Novo"
          deleteItem={handleDelete}
          onClickEdit={(item) =>
            props.history.push(`/bodymetrix-regiao/${item.id}`)
          }
          onClickNew={() => props.history.push("/bodymetrix-regiao/new")}
          getPage={getPage}
          getCount={getCount}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function BodymetrixRegiaoForm(props) {
  const validate = (values) => ({
    nome: values.nome ? undefined : "Obrigatório",
  });

  return (
    <FormApi api={bodymetrixRegiaoApi} {...props}>
      {({ handleSubmit, getItem }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container direction="column" spacing={16}>
            <Grid item>
              <Grid container spacing={16}>
                <Grid item sm>
                  <Field
                    fullWidth
                    autoFocus
                    component={TextField}
                    label="Região do corpo"
                    name="nome"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}
